const DashboardSpeed = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 3.33337L10 6.66671" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3.3335 6.66663L5.41683 8.74996" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M14.5835 8.74996L16.6668 6.66663" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.5 14.1666L5 14.1666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 14.1666L10.8333 9.16663" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15 14.1666L17.5 14.1666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M7.08317 16.6675H3.33317C2.28665 15.2746 1.6665 13.5431 1.6665 11.6667C1.6665 7.06433 5.39746 3.33337 9.99984 3.33337C14.6022 3.33337 18.3332 7.06433 18.3332 11.6667C18.3332 13.5431 17.713 15.2746 16.6665 16.6675L12.9165 16.6667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 19.1666C11.3807 19.1666 12.5 18.0473 12.5 16.6666C12.5 15.2859 11.3807 14.1666 10 14.1666C8.61929 14.1666 7.5 15.2859 7.5 16.6666C7.5 18.0473 8.61929 19.1666 10 19.1666Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DashboardSpeed;
